import axios from 'axios';
import ArticleAction from './ActionType';

const ARTICLE_API_BASE = '/api/article'

export default {
  namespaced: true,
  state: {
    articles: [],
    pagination: {},
    article: {}
  },
  getters: {
  },
  mutations: {
    // 댓글 처리
    [ArticleAction.ARTICLE_REPLY]: (state, reply) => {
      const commentIx = state.article.comments.findIndex(c => c._id === reply.commentId);
      const comment = state.article.comments[commentIx];
      comment.replies.push(reply);
    },
    [ArticleAction.ARTICLE_UPDATE_REPLY]: (state, reply) => {
      const commentIx = state.article.comments.findIndex(c => c._id === reply.commentId);
      const comment = state.article.comments[commentIx];
      const replyIx = comment.replies.findIndex(c => c._id === reply._id);
      comment.replies.splice(replyIx, 1, reply);
    },
    [ArticleAction.ARTICLE_DELETE_REPLY]: (state, reply) => {
      const commentIx = state.article.comments.findIndex(c => c._id === reply.commentId);
      const comment = state.article.comments[commentIx];
      const replyIx = comment.replies.findIndex(c => c._id === reply._id);
      comment.replies.splice(replyIx, 1);
    }
  },
  actions: {
    // 댓글 Actions
    [ArticleAction.ARTICLE_REPLY]: async ({ commit }, reply) => {
      const { data } = await axios.post(`${ARTICLE_API_BASE}/reply/${reply.commentId}`, reply);
      commit(ArticleAction.ARTICLE_REPLY, data);
    },
    [ArticleAction.ARTICLE_UPDATE_REPLY]: async ({ commit }, { replyId, content }) => {
      const { data } = await axios.put(`${ARTICLE_API_BASE}/reply/${replyId}`, { content });
      commit(ArticleAction.ARTICLE_UPDATE_REPLY, data);
    },
    [ArticleAction.ARTICLE_DELETE_REPLY]: async ({ commit }, reply) => {
      await axios.delete(`${ARTICLE_API_BASE}/reply/${reply._id}`);
      commit(ArticleAction.ARTICLE_DELETE_REPLY, reply);
    }
  }
}
